<template>
  <Layout
    :title="meta.title"
    max-width="100%"
  >
    <section class="is-card consult">
      <p>
        Preencha os dados para consultar as informações do seu cliente e prosseguir com a
        simulação.
      </p>

      <v-validate-observer
        ref="form"
        v-slot="{ handleSubmit }"
      >
        <form
          class="consult__form"
          @submit.prevent="handleSubmit(consult)"
        >
          <div class="consult__fields">
            <v-validate
              v-slot="{ errors }"
              rules="required|length:14|CPF"
              name="Documento"
            >
              <BaseInput
                v-model="form.document"
                :error-message="errors[0]"
                class="document"
                type="tel"
                maxlength="15"
                mask="cpf"
                :show-copy-icon="true"
              >
                CPF
              </BaseInput>
            </v-validate>

            <v-validate
              v-slot="{ errors }"
              rules="required"
              name="Esteira"
            >
              <BaseSelect
                v-model="form.supplier_id"
                class="bank"
                :error-message="errors[0]"
                :options="suppliers"
              >
                Esteira
              </BaseSelect>
            </v-validate>

            <v-validate
              v-if="isSupplierPrataAuto"
              v-slot="{ errors }"
              rules="required"
              name="Placa"
            >
              <BaseInput
                v-model="form.vehicle_license"
                class="bank"
                :error-message="errors[0]"
              >
                Placa
              </BaseInput>
            </v-validate>

            <v-validate
              v-if="isSupplierPrataAuto"
              v-slot="{ errors }"
              rules="required"
              name="Veículo quitado?"
            >
              <BaseSelect
                v-model="form.cleared"
                class="bank"
                :error-message="errors[0]"
                :options="list.cleared"
              >
                Veículo quitado?
              </BaseSelect>
            </v-validate>

            <v-validate
              v-if="isSupplierPrataAuto"
              v-slot="{ errors }"
              rules="required|prataAutoAllowedUf"
              name="Estado do veículo"
            >
              <BaseSelect
                v-model="form.vehicle_uf"
                class="bank"
                :error-message="errors[0]"
                :options="states"
              >
                Estado do veículo
              </BaseSelect>
            </v-validate>

            <button
              class="button is-success"
              type="submit"
            >
              Iniciar simulação
            </button>
          </div>
        </form>
      </v-validate-observer>
    </section>
    <section class="is-card consult-table">
      <div class="consult-table__header">
        <h1 class="font-xl is-bolder">
          Histórico de simulações
        </h1>
        <p>Acompanhe as simulações realizadas hoje. O cache é limpo todos os dias à meia-noite.</p>

        <button
          class="button is-success is-link"
          @click="getWaitList(null, true)"
        >
          <i>
            <ReloadSVG />
          </i>
          {{ !isMobile ? 'Recarregar' : '' }}
        </button>
      </div>
      <div class="consult-table__search">
        <BaseInput
          v-if="tableData.length > 0"
          v-model="form.search"
          placeholder="Buscar por nome ou CPF"
          class="bank"
        />

        <button
          v-if="tableData.length > 0"
          class="button is-success"
          @click="getWaitList({ search: form.search })"
        >
          Buscar
        </button>
      </div>
      <div class="consult-table__actions">
        <button
          v-if="selectedRows.length"
          class="button is-danger is-light"
          @click="deleteWaitList"
        >
          Remover
          {{ selectedRows.length > 1
            ? `${selectedRows.length} itens`
            : `${selectedRows.length} item`
          }}
        </button>
      </div>
      <div
        v-if="tableData.length > 0"
        class="data-table"
      >
        <table
          v-if="isMobile"
          class="table"
          aria-label="Tabela de dados"
        >
          <caption class="is-sr-only">
            Tabela de dados
          </caption>
          <tbody>
            <tr
              v-for="(item, index) in tableData"
              :key="index"
              :class="{
                'is-checked': selectedRows.includes(item.id),
              }"
            >
              <!-- checkbox -->
              <td
                class="checkbox"
              >
                <BaseCheckbox
                  :value="selectedRows.includes(item.id)"
                  :name="item.id"
                  @input.prevent="toggleChecked(item.id)"
                />
              </td>
              <div class="data">
                <div>
                  <th scope="col">
                    <p>CPF</p>
                  </th>
                  <td><p>{{ item.document }}</p></td>
                </div>
                <div>
                  <th scope="col">
                    <p>Nome</p>
                  </th>
                  <td><p>{{ item.name }}</p></td>
                </div>

                <div>
                  <th scope="col">
                    <p>Veículo</p>
                  </th>
                  <td><p>{{ item.vehicle }}</p></td>
                </div>

                <div>
                  <th scope="col">
                    <p>Valor solicitado</p>
                  </th>
                  <td><p>{{ item.amount | money }}</p></td>
                </div>

                <div>
                  <th scope="col">
                    <p>Parcelamento</p>
                  </th>
                  <td><p>{{ item.installments }}x {{ item.installment_value | money }}</p></td>
                </div>
              </div>

              <!-- action -->
              <div class="table-action">
                <button
                  class="button"
                  @click.prevent="expandRow(item)"
                >
                  Ver resultado
                </button>
              </div>

              <!-- expanded data -->
              <div
                v-if="expandedRow === item.id && item.status !== 'processing'"
                class="expanded-row has-background-white"
              >
                <section class="expanded-row__content">
                  <section class="information__card">
                    <section class="information__card__amount">
                      <p class="information__card__amount__label">
                        Valor solicitado
                      </p>
                      <p class="font-ul is-extra-bolder information__card__amount__value">
                        {{ item.amount | money }}
                      </p>
                    </section>
                    <section class="information__card__installments">
                      <p class="information__card__installments__label">
                        Parcelamento
                      </p>
                      <p class="is-bold information__card__installments__value">
                        <small>
                          {{ item.installments }}x
                        </small>
                        {{ item.installment_value | money }}
                      </p>
                    </section>
                    <button
                      class="button information__card__button"
                      @click="downloadTable"
                    >
                      <IconSave
                        state="is-blue"
                        class="not-stroke"
                      />

                      <template v-if="!isMobile">
                        Copiar como imagem
                      </template>
                    </button>
                  </section>
                  <section class="information">
                    <header class="information__header">
                      <p>Por que não posso alterar essa simulação?</p>
                    </header>
                    <p class="information__text">
                      Para criação de uma proposta, a simulação deverá sempre ser realizada e
                      confirmada anteriormente. Para realizar uma nova simulação, digite o CPF
                      e Placa do cliente desejado e clique em
                      <strong>”Iniciar Simulação”</strong>.
                    </p>
                  </section>
                  <button
                    class="button is-success formatization_button"
                    @click="goToFormalization(item)"
                  >
                    Preencher cadastro dessa proposta
                  </button>
                </section>
              </div>
            </tr>
          </tbody>
        </table>
        <table
          v-else
          class="table"
          aria-label="Tabela de dados"
        >
          <caption class="is-sr-only">
            Tabela de dados
          </caption>
          <thead>
            <tr>
              <th scope="col">
                <BaseCheckbox
                  :value="selectedRows"
                  :max="tableData.length"
                  @input.prevent="toggleChecked()"
                />
              </th>
              <th scope="col" class="left-aligned">
                Cliente
              </th>
              <th scope="col" class="left-aligned">
                Veículo
              </th>
              <th scope="col" class="left-aligned">
                Esteira
              </th>
              <th scope="col" class="left-aligned small-column">
                Valor Solicitado
              </th>
              <th scope="col">
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(item, index) in tableData"
            >
              <tr
                :key="index"
                :class="{
                  'is-checked': selectedRows.includes(item.id),
                }"
              >
                <td>
                  <BaseCheckbox
                    :value="selectedRows.includes(item.id)"
                    :name="item.id"
                    @input.prevent="toggleChecked(item.id)"
                  />
                </td>
                <td class="left-aligned">
                  <p class="is-semi-bold is-highlighted">
                    {{ item.document }}
                  </p>
                  <p>{{ item.name }}</p>
                </td>
                <td class="left-aligned">
                  <p>
                    {{ item.vehicle_name }}
                  </p>
                </td>
                <td class="left-aligned">
                  <p class="is-semi-bold">
                    {{ getSupplierNameById(item.supplier_id) || 'BMP' }}
                  </p>
                </td>
                <td class="left-aligned small-column">
                  <p class="is-highlighted">
                    {{
                      item.wish_amount
                        ? item.wish_amount
                        : item.amount | money
                    }}
                  </p>
                  <p>{{ item.installments }}x {{ item.installment_value | money }}</p>
                </td>
                <td>
                  <button
                    class="button"
                    @click.prevent="expandRow(item)"
                  >
                    Ver resultado
                  </button>
                </td>
              </tr>
              <tr
                v-if="expandedRow === item.id"
                :key="index"
                class="expanded-row has-background-white"
              >
                <td colspan="6">
                  <section class="expanded-row__content">
                    <!-- First Column -->
                    <section class="information__card">
                      <section class="information__card__amount">
                        <p class="information__card__amount__label">
                          Valor solicitado
                        </p>
                        <p class="font-ul is-extra-bolder information__card__amount__value">
                          {{ item.amount | money }}
                        </p>
                      </section>
                      <section class="information__card__installments">
                        <p class="information__card__installments__label">
                          Parcelamento
                        </p>
                        <p class="is-bold information__card__installments__value">
                          <small>
                            {{ item.installments }}x
                          </small>
                          {{ item.installment_value | money }}
                        </p>
                      </section>
                      <button
                        class="button information__card__button"
                        @click="downloadTable"
                      >
                        <IconSave
                          state="is-blue"
                          class="not-stroke"
                        />

                        Copiar como imagem
                      </button>
                    </section>
                    <!-- Second Column -->
                    <section class="information">
                      <header class="information__header">
                        <p>Por que não posso alterar essa simulação?</p>
                      </header>
                      <p class="information__text">
                        Para criação de uma proposta, a simulação deverá sempre ser realizada e
                        confirmada anteriormente. Para realizar uma nova simulação, digite o CPF
                        e Placa do cliente desejado e clique em
                        <strong>”Iniciar Simulação”</strong>.
                      </p>
                    </section>
                    <!-- Formalization button -->
                    <button
                      class="button is-success formatization_button"
                      @click="goToFormalization(item)"
                    >
                      Preencher cadastro dessa proposta
                    </button>
                  </section>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div
        v-else
        class="empty-state mt-5"
      >
        <IconRocketGirl />
        <p class="font-lg is-bold">
          Pronto para iniciar o dia?
        </p>
        <p class="is-bold">
          Você ainda não realizou nenhuma simulação.
        </p>
        <p>Comece inserindo o CPF e o banco que deseja simular.</p>
      </div>
    </section>

    <!-- Optin Cliente Modal -->
    <OptInClientModal
      v-if="modal.optInClient"
      :document="form.document"
      :link="termLink"
      @close="modal.optInClient = false"
    />

    <!-- Not Elegible Modal -->
    <NotElegibleModal
      v-if="modal.notElegible"
      @close="modal.notElegible = false"
    />
  </Layout>
</template>

<script>
/** Core */
import { mapGetters, mapActions, mapState } from 'vuex';
import html2canvas from 'html2canvas';
import { toast } from 'bulma-toast';

/** Mixins */
import loadingMixin from '@/mixins/loadingView.mixin';
import errorHandlerMixin from '@/mixins/errorHandler.mixin';
import useTheme from '@/composables/theme';

/** Utils */
import seo from '@/utils/seo';
import { isDomain } from '@/utils';

/** Data */
import config from '@/data/config';
import statesData from '@/data/states.json';

/** Services */
import {
  clients as ClientAPI,
  cgv as CGVAPI,
} from '@/services';

export default {
  name: 'CGVConsult',
  components: {
    ReloadSVG: () => import('@/assets/icons/Reload.vue'),
    IconRocketGirl: () => import('@/assets/icons/RocketGirl.vue'),
    IconSave: () => import('@/assets/icons/Save.vue'),
    Layout: () => import('@/layouts/Layout.vue'),
    BaseInput: () => import('@/components/Base/Input/index.vue'),
    BaseSelect: () => import('@/components/Base/Select/index.vue'),
    BaseCheckbox: () => import('@/components/BaseCheckbox.vue'),
    OptInClientModal: () => import('@/components/ModalData/OptInClientModal.vue'),
    NotElegibleModal: () => import('@/components/CGV/NotElegibleModal.vue'),
  },
  mixins: [loadingMixin, errorHandlerMixin],
  data() {
    return {
      meta: {
        title: 'Crédito com Garantia em Veículo',
      },
      expandedRow: null,
      expandedItem: null,
      form: {
        document: '',
        supplier_id: '',
        search: '',
        vehicle_license: '',
        cleared: '',
        vehicle_uf: '',
      },
      selectedRows: [],
      tableData: [],
      modal: {
        optInClient: false,
        notElegible: false,
      },
      list: {
        cleared: [
          { name: 'Sim', value: true },
          { name: 'Não', value: false },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'app/isMobile',
    }),
    ...mapState({
      stateConsult: (state) => state.consult.consult,
      suppliers: (state) => state.app.suppliers,
    }),
    termLink() {
      let prefix = 'assina';
      if (isDomain('dittobank')) prefix = 'fgts';
      if (isDomain('topmaistop')) prefix = 'sign';

      return `http://${prefix}.${useTheme().domain()}/credito-com-garantia-em-veiculo/termo-autorizacao`;
    },
    isSupplierPrataAuto() {
      return this.form.supplier_id === config.SUPPLIER_ID_PRATA_AUTO;
    },
    states() {
      return statesData.map(({ nome, sigla }) => ({ name: nome, value: sigla }));
    },
  },
  created() {
    this.setConsult({});
  },
  async mounted() {
    await this.getSuppliersList(config.PRODUCT_ID_CGV);
    this.getWaitList();
  },
  methods: {
    ...mapActions({
      setConsult: 'consult/SET_CONSULT',
      getSuppliersList: 'app/SET_SUPPLIERS',
    }),
    getSupplierNameById(id) {
      const { name } = this.suppliers.find((sup) => sup.value === id) || '';
      return name;
    },

    // handlers
    expandRow(data) {
      this.expandedRow = this.expandedRow === data.id
        ? null
        : data.id;
    },
    toggleChecked(id) {
      const tableHeadCheckbox = document.querySelector('th .checkbox');
      if (id) {
        const isChecked = !!this.selectedRows.find((elem) => elem === id);

        if (isChecked) {
          this.selectedRows.splice(this.selectedRows.indexOf(id), 1);
        } else {
          this.selectedRows.push(id);
        }

        document.querySelector(`.checkbox[name="${id}"]`)
          .classList.toggle('checked-checkbox');
      } else if (this.selectedRows.length > 0) {
        this.tableData.forEach((elem) => {
          document.querySelector(`.checkbox[name="${elem.id}"]`)
            .classList.toggle('checked-checkbox');

          return elem.id;
        });

        this.selectedRows = [];
        tableHeadCheckbox.classList.toggle('checked-checkbox');
      } else {
        tableHeadCheckbox.classList.toggle('checked-checkbox');

        this.selectedRows = this.tableData.map((elem) => {
          document.querySelector(`.checkbox[name="${elem.id}"]`)
            .classList.toggle('checked-checkbox');

          return elem.id;
        });
      }
    },
    downloadTable() {
      const tableToExport = document.querySelector('.information__card');

      html2canvas(tableToExport)
        .then((canvas) => {
          canvas.getContext('2d', { willReadFrequently: true });

          if (window.ClipboardItem.supports('image/png')) {
            canvas.toBlob((blob) => {
              navigator.clipboard.write([
                new window.ClipboardItem({ 'image/png': blob }),
              ]);
            });
          } else {
            const dataUrl = canvas.toDataURL();
            const anchor = document.createElement('a');
            anchor.href = dataUrl;
            anchor.download = 'simulacao-cgv.png';
            anchor.click();
          }

          toast({
            message: 'Imagem copiada com sucesso!',
            type: 'is-success',
            dismissible: true,
            pauseOnHover: true,
            animate: { in: 'fadeIn', out: 'fadeOut' },
            position: 'top-center',
            closeOnClick: true,
          });
        });
    },

    async goToFormalization({
      document,
      vehicle_name,
      vehicle_id,
      wish_amount,
      installments,
      installment_value,
      id,
      supplier_id,
      supplier_name,
      cet_monthly,
      cet_year,
      installments_total,
      total_debit,
      total_financed,
    }) {
      await this.setConsult({
        cgv_wait_list_id: id,
        document,
        vehicle_name,
        vehicle_id,
        wish_amount,
        installments,
        installment_value,
        supplier_id,
        supplier_name,
        cet_monthly,
        cet_year,
        installments_total,
        total_debit,
        total_financed,
      });
      this.$router.push('/cgv/formalizacao');
    },

    // API
    async consult() {
      try {
        this.loading = true;

        const {
          document, supplier_id, vehicle_license, cleared, vehicle_uf,
        } = this.form;
        const cleanDocument = document.replace(/\D/g, '');

        const params = { supplier_id, document: cleanDocument };
        if (this.isSupplierPrataAuto) {
          params.vehicle_license = vehicle_license;
          params.cleared = cleared;
          params.vehicle_uf = vehicle_uf;
        }

        const { data: response } = await CGVAPI.validateClientEligibility(params);

        // Documento não elegível
        if (!response.elegible) {
          this.modal.notElegible = true;
          return;
        }

        await ClientAPI.getClientData(cleanDocument)
          .then(({ data: clientData }) => {
            if (!clientData.name || !clientData.document || !clientData.birthdate) {
              this.modal.optInClient = true;
            } else { /* Caso tudo esteja preenchido, manda pra simulação */
              this.setConsult({ ...params, document });
              this.$router.push('/cgv/simulacao');
            }
          })
          .catch(() => {
            this.modal.optInClient = true;
          });
      } catch (err) {
        this.handlerError(err);
      } finally {
        this.loading = false;
      }
    },

    // API
    deleteWaitList() {
      this.loading = true;

      const params = {
        ids: this.selectedRows,
      };

      return CGVAPI.deleteWaitList(params)
        .then(() => {
          this.tableData = this.tableData.filter((elem) => !this.selectedRows.includes(elem.id));
          this.selectedRows = [];
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
    getWaitList(params = null, clearList = false) {
      this.loading = true;

      if (clearList) this.tableData = [];

      CGVAPI.getWaitList(params)
        .then(({ data }) => {
          this.tableData = data;
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
  },
  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';
@import '@/assets/scss/src/_buttonsVariables.scss';

.consult {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.data-table {
  width: 100%;
}
.empty-state {
  text-align: center;
  flex-basis: 100%;
}

.header {
  margin-top: 30px;
}
.is-card {
  box-shadow: 0 1px 1px 1px rgba(10, 10, 10, 0.1);
  padding: 24px 15px;
  border-radius: 8px;
  margin: 16px 0;
  background-color: #FFF;
}

.consult__form {
  .consult__fields {
    display: grid;
    grid-template-columns: 1fr;
    // each field keeps its own natural height instead of stretching to
    // match a neighbor whose error message wraps onto multiple lines
    align-items: start;
    gap: 16px;

    // button is a grid item, not a flex sibling, so it never leaves a gap
    // behind conditional fields (e.g. Placa/Veículo quitado?/Estado do veículo)
    button {
      grid-column: 1 / -1;
      min-height: 42px;
      align-self: stretch;
    }
  }

  // tablet: fields flow into a fixed 3-column grid, button stays full-width below
  @media (min-width: 768px) {
    .consult__fields {
      grid-template-columns: repeat(3, minmax(160px, 1fr));
    }
  }

  // desktop wide: column count follows however many fields are actually
  // visible (2 when the supplier isn't Prata Auto, 5 when it is), button anchored
  // to the last column of that same row instead of a fixed 5-column track
  @media (min-width: 1200px) {
    .consult__fields {
      grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));

      button {
        grid-column: -1;
        align-self: start;
        width: auto;
        // offsets the label's height so the button's top lines up with the
        // inputs' top, not the labels' — stays put no matter which fields error out
        margin-top: 20px;
      }
    }
  }
}

.consult-table {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  &__header {
    p {
      color: map.get($stone-types, '500');
    }
    position: relative;

    button {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  &__search, &__actions {
    flex-basis: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 24px;
    margin: 8px 0;

    .button {
      height: 38px;
    }

    .control {
      display: inline-block;
    }
  }

  .control {
    flex-grow: 1;
  }
  &__header {
    flex-basis: 100%;
  }
  button {
    align-self: center;
  }

  .table {
    border: 1px solid $gray-200;
    border-radius: 8px;
    border-collapse: separate;
    width: 100%;

    .checkbox input:checked {
      color: $prata-green-600;
      background-color: $prata-green-600;
      border-color: $prata-green-600;
    }
    tr {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-areas:
        'checkbox data'
        'tag      tag'
        'action  action'
        'expanded expanded';
      grid-template-rows: auto;
      padding: 16px 0;

      th, td {
        border: none;
        padding: 0 12px;
        margin-top: 4px;
      }

      .checkbox {
        grid-area: checkbox;
        align-self: center;

        &.checked-checkbox {
          color: $prata-green-600;
        }
      }
      .data {
        grid-area: data;

        div {
          display: flex;
          justify-content: space-between;

          th {
            flex-basis: 50%;
            p {
              line-height: 20px;
              color: map.get($stone-types, '500');
            }
          }

          td {
            flex-basis: 50%;
            p {
              line-height: 20px;
              color: map.get($stone-types, '900');
              text-align: right;
            }
          }
        }
      }

      .table-status {
        grid-area: tag;
      }

      .table-action {
        grid-area: action;
      }

      &:nth-child(even) {
        background-color: #FAFAF9;
      }

      &.is-checked {
        background-color: $prata-green-50;
      }

      .table-status, .table-action {
        margin-top: 16px;
        text-align: center;

        button {
          width: 90%;
        }
      }
    }
  }
}

.expanded-row {
  grid-area: expanded;
  padding: 16px;

  td {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &__content {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    .information {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 16px;
      padding: 24px;
      background: #FBFCFD;
      border-radius: 8px;

      header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
          font: 700 14px 'Inter', sans-serif;
          line-height: 120%;
          color: black !important;
        }
      }

      .information__text {
        text-align: left;
        font: 400 14px 'Inter', sans-serif;
        line-height: 24px;
        color: black;
      }

      &__card {
        padding: 24px;
        border: 1px solid $prata-green-600;
        border-radius: 8px;
        gap: 16px;
        display: grid;
        grid-template-areas:
        'amount button'
        'installments button';

        &__amount {
          grid-area: amount;
          justify-self: flex-start;
          text-align: left;
          display: flex;
          flex-direction: column;
          gap: 6px;

          &__label {
            font: 400 14px 'Inter', sans-serif;
            line-height: 20px;
            color: black !important;
          }
          &__value {
            font: 900 24px 'Inter', sans-serif;
            color: $prata-green-700 !important;
          }
        }
        &__installments {
          grid-area: installments;
          justify-self: flex-start;
          text-align: left;
          display: flex;
          flex-direction: column;
          gap: 8px;

          &__label {
            font: 400 14px 'Inter', sans-serif;
            line-height: 20px;
            color: black !important;
          }
          &__value {
            font: 600 18px 'Inter', sans-serif;
            line-height: 20px;
            letter-spacing: 6%;
            color: $gray-900 !important;

            small {
              font: 400 14px 'Inter', sans-serif;
              line-height: 20px;
              color: $gray-900;
            }
          }
        }
        &__button {
          grid-area: button;
          width: fit-content;
          gap: 8px;
          padding: 8px 16px;
          justify-self: flex-end;
        }
      }
    }

    .formatization_button {
      width: 100%;
    }

    @media only screen and (min-width: 1024px) {
      grid-template-columns: 1fr 1fr;
    }
  }
}

@media only screen and (min-width: 1024px) {
  .consult-table {
    table.table {
      tr {
        border: none;
        display: table-row;

        th, td {
          padding: 5px 23px;
          vertical-align: middle;
          width: 25%;
          text-align: center;
          color: map.get($stone-types, "500");
          &:first-of-type {
            width: 62px;
          }
          &.left-aligned {
            text-align: left;
          }
          &.small-column {
            width: 14%;
          }
          p {
            color: map.get($stone-types, "500");

            &.is-highlighted {
              color: map.get($stone-types, "900");
            }
          }
        }

        th {
          border-bottom: 1px solid map.get($stone-types, "200");
          background-color: map.get($stone-types, "50");
          text-transform: uppercase;
          letter-spacing: 0.05rem;
          text-align: center;
        }

        &.is-checked {
          background-color: $prata-green-50;
        }

        &--header {
          color: map.get($stone-types, "500");
        }

        &--content {
          color: map.get($stone-types, "800");
        }

        button {
          margin-top: 0;
        }

        .table-status, .table-action {
          text-align: center;

          button {
            margin-top: 0;
            padding: 7px 11px;
            width: 100px;
          }
        }
      }
    }
  }
  .consult-table table.table tr td {
    > div {
      padding: 16px 0;
      border-top: 1px solid map.get($stone-types, '300');
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .expanded-values {
        text-align: left;
        border: 1px solid $prata-green-600;
        border-radius: 8px;
        margin: 0 16px;
        padding: 24px;
        flex-basis: 40%;
        display: flex;
        justify-content: space-between;

        .font-ul {
          color: $prata-green-700;
        }

        button {
          align-self: center;
          padding: 8px;

          svg {
            width: 15px;
            height: 15px;
          }
        }
      }
      .expanded-info {
        text-align: left;
        padding: 24px;
        flex-basis: 35%;

        > div:first-child {
          display: flex;
        }
      }
      button {
        svg {
          margin-right: 8px;
        }
        flex-basis: 40%;
        margin: 20px;
      }
    }
  }
}
</style>
